import React, {useCallback, useContext} from 'react';
import {useHistory} from 'react-router-dom';
import {HelpCircleIcon, Button} from '@customink/pigment-react';
import {IconButtonProps} from '@mui/material/IconButton';
import services from '../../api/remoteServices';
import {MobileContext} from '../../containers/MobileProvider';
import HomepageLogo from '../HomepageLogo';
import './index.scss';

export type ContainerProps = React.HTMLAttributes<HTMLDivElement>;

export interface LinkProps extends IconButtonProps {
  targetLink?: string;
  isDisabled?: boolean;
  isSelected?: boolean;
  label?: string;
  icon?: JSX.Element;
}

const Link: React.FC<LinkProps> = ({
  targetLink,
  className,
  onClick,
  isDisabled,
  isSelected,
  label,
  icon
}: LinkProps) => {
  const history = useHistory();
  const navigationCallback = useCallback(
    event => {
      if (targetLink) history.push(targetLink);
      else if (onClick) onClick(event);
    },
    [targetLink, onClick]
  );
  const mobile = useContext(MobileContext);

  let classes = 'sidebar-link';
  if (className) classes += ` ${className}`;
  if (isSelected) classes += ` selected`;
  const shouldHideLabel = mobile && !isSelected;
  return (
    <Button
      variant="secondary"
      aria-label={`${label} Button`}
      size="large"
      onClick={navigationCallback}
      className={classes}
      disabled={isDisabled}
      startIcon={icon}>
      {shouldHideLabel ? '' : label}
    </Button>
  );
};

const Container: React.FC<ContainerProps> = ({children}: ContainerProps) => {
  const mobile = useContext(MobileContext);
  return (
    <div className={`sidebar${mobile ? '-mobile' : ''}`}>
      {mobile ? null : <HomepageLogo />}
      <div className="sidebar-links">
        {children}
        <Button
          className="sidebar-link"
          href={`${services.homePage}/ink/online-stores-organizer-faq`}
          startIcon={<HelpCircleIcon />}
          size="large"
          variant="secondary"
          target="_blank"
          rel="noreferrer"
          role="link">
          {mobile ? '' : 'Help'}
        </Button>
      </div>
    </div>
  );
};

Link.defaultProps = {
  targetLink: null,
  isDisabled: false,
  isSelected: false,
  label: null,
  icon: null
};

export default {Container, Link};
